import { Box } from "../Box";

interface PageContainerProps {
  children: any;
  className?: string;
}

export const PageContainer = ({ children, className }: PageContainerProps) => {
  return (
    <Box
      className={className}
      width="100%"
      height="100%"
      pl="md"
      pr="md"
      pb="xxl"
    >
      {children}
    </Box>
  );
};
